import {
  isViewportLiteral,
  Viewport,
  type ViewportLiteral,
} from "../pixel-accessor";
import { isPoint } from "../types";
import type { DistortionProcessor } from "./DistortionProcessor";
import { type ImageAdapter } from "../image-adapter";
import type { ColorResampler } from "../color-resampler";
import type { Point } from "../types";

/**
 * Proxy for performing image virtual viewport re-paging after distortion process.
 */
export class RepageProxy implements DistortionProcessor {
  /**
   * RepageProxy constructor.
   *
   * @param processor
   * @param repage
   */
  constructor(
    private readonly processor: DistortionProcessor,
    private readonly repage?: Point | ViewportLiteral
  ) {}

  /**
   * Applies provided offset to image virtual viewport or resets image viewport offset to (0, 0) if no offset was provided.
   *
   * @param targetImage
   * @param resampler
   */
  async process<ResourceType>(
    targetImage: ImageAdapter<ResourceType>,
    resampler: ColorResampler
  ): Promise<ImageAdapter<ResourceType>> {
    const result = await this.processor.process(targetImage, resampler);
    result.getViewport().reset();
    if (isPoint(this.repage)) {
      result.getViewport().offset(...this.repage);
    } else if (isViewportLiteral(this.repage)) {
      result.setViewport(Viewport.fromLiteral(this.repage));
    }
    return result;
  }
}
